import { toast } from 'react-toastify';
import * as api from '../api/vehicleApi';
import * as types from '../constants/vehicleConstans';

export const createVehicleAction = (vehicle, navigate) => async () => {
  try {
    const { error, data } = await api.createVehicle(vehicle);
    if (error) {
      throw new Error(error);
    }
    navigate(`/vehicles/${data.vin}`);
    toast.success('Автомобіль було успішно додано');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося додати автомобіль');
  }
};

export const updateVehicleAction = (vin, vehicle) => async () => {
  try {
    const { error } = await api.updateVehicle(vin, vehicle);
    if (error) {
      throw new Error(error);
    }
    toast.success('Автомобіль було успішно змінено');
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося змінити автомобіль');
  }
};

export const getVehicleAction = (vehicleId, vin) => async (dispatch) => {
  dispatch({ type: types.GET_VEHICLE_REQUEST });
  try {
    const { error, data } = await api.getVehicle(vehicleId, vin);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_VEHICLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    toast.error(error?.message ? error.message : 'Не вдалося завантажити автомобіль');
    dispatch({ type: types.GET_VEHICLE_FAILURE });
  }
};

export const cleanVehicleActions = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_VEHICLE,
  });
};
